<template>
    <div id="app">
        <the-background id="the-background" class="fullscreen" />

        <the-scroller />

        <scroll-timeline />

        <venn-diagram />

        <the-topics />

        <the-frame />

        <transition name="fade">
            <sign-up v-if="showSignUp" @close="closeSignUp" />
        </transition>
    </div>
</template>

<script>
// Utils & Mixins
import resizeMixin from '@/mixins/resizeMixin'
import { mapState } from 'vuex'

import TheBackground from '@/assets/svg/background-grid.svg'
import SignUp from '@/views/SignUp'

import TheTopics from '@/components/Topics/TheTopics'
import VennDiagram from '@/components/VennDiagram/VennDiagram'

import TheScroller from '@/components/TheScroller'
import TheFrame from '@/components/frame/TheFrame'

import ScrollTimeline from '@/components/ScrollTimeline'

// import { page } from 'vue-analytics'

export default {
    name: 'app',

    mixins: [resizeMixin],

    computed: {
        ...mapState(['showSignUp']),
    },

    components: {
        TheBackground,
        SignUp,
        TheTopics,
        VennDiagram,
        TheFrame,
        TheScroller,
        ScrollTimeline,
    },

    mounted() {
        // force scroll to top for refresh
        window.onbeforeunload = function () {
            window.scrollTo(0, 0)
        }

        this.track()
    },

    methods: {
        openSignUp() {
            this.$store.commit('openSignUp')
        },

        closeSignUp() {
            this.$store.commit('closeSignUp')
        },

        track() {
            this.$ga.page('/strategy-blueprint/')
        },
    },
}
</script>

<style lang="stylus">
html::-webkit-scrollbar {
  width: 0px;
  display: none;
}

html {
  scrollbar-width: none;
}

body {
  overscroll-behavior: none;
}

svg {
  overflow: visible;
}

text {
  text-rendering: optimizeLegibility;
}

#app {
  width: 100%;
  height: 100vh;
}

.fullscreen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
}

#the-graphic {
  position: fixed;
  top: 80px;
  left: 40px;
  width: calc(100% - 80px);
  height: calc(100vh - 80px);
}

.sign-up-button {
  position: fixed;
  top: 40px;
  right: 40px;
  background-color: white;
  color: black;
}

svg text {
  user-select: none;
}
</style>
